'use client';

import { useState } from 'react';

import { CustomLink } from '@/components/custom-link';

import { AdblockModal } from '../adblock-modal';

type EvidonScript = {
  notice: {
    showOptions: () => void;
  };
};

type WindowWithEvidon = Window & {
  evidon?: EvidonScript;
};

const ManageCookiePreferences = () => {
  const [isAdblockModalOpen, setIsAdblockModalOpen] = useState<boolean>(false);

  return (
    <>
      <CustomLink
        className="block !text-gray-700 hover:!text-information"
        href=""
        onClick={(e) => {
          e.preventDefault();
          const evidon = (window as WindowWithEvidon).evidon ?? null;

          if (evidon?.notice) {
            evidon.notice.showOptions();
          } else {
            setIsAdblockModalOpen(true);
          }
        }}
      >
        Cookie preferences
      </CustomLink>
      <AdblockModal
        isModalOpen={isAdblockModalOpen}
        setIsModalOpen={setIsAdblockModalOpen}
      />
    </>
  );
};

export { ManageCookiePreferences };
